import { render, staticRenderFns } from "./SemiCircleGauge.vue?vue&type=template&id=2a90d2c2&scoped=true&"
import script from "./SemiCircleGauge.vue?vue&type=script&lang=ts&"
export * from "./SemiCircleGauge.vue?vue&type=script&lang=ts&"
import style0 from "./SemiCircleGauge.vue?vue&type=style&index=0&id=2a90d2c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90d2c2",
  null
  
)

export default component.exports